<template>
  <div>
    <div class="columns toolbar-box action-right">
      <div class="column is-3">
        <h1 class="title is-3 between-center">
                    <span>
                        <span>Pending change orders</span>
                    </span>
        </h1>
      </div>
      <div class="column is-4-tablet is-2-desktop">
        <o-field>
          <autocomplete-select
              v-model="filters.companyId"
              type="company"
              field-name="name"
              placeholder="Search by Company"
              @update:modelValue="fetchReportData()"
          />
        </o-field>
      </div>
      <div class="column is-4-tablet is-2-desktop">
        <o-field>
          <Datepicker
              v-model="filters.from"
              class="input"
              @update:modelValue="fetchReportData()"
              placeholder="Date start"/>
        </o-field>
      </div>
      <div class="column is-4-tablet is-2-desktop">
        <o-field>
          <o-field>
            <Datepicker
                v-model="filters.to"
                class="input"
                @update:modelValue="fetchReportData()"
                placeholder="Date end"/>
          </o-field>
        </o-field>
      </div>
    </div>

    <o-table
        table-class="report-table"
        :data="rows"
        :loading="loading"
        :total="total"
        :per-page="perPage"
        paginated
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        backend-sorting
        :default-sort-direction="defaultSortOrder"
        :default-sort="[sortField, sortOrder]"
        @page-change="onPageChange"
        @sort="onSort">
      <template>
        <template>
          <o-table-column
              #default="{row}"
              v-for="(col, idx) in columns" :key="idx + '_' + col.field"
              :field="col.field"
              :label="col.label"
              :sortable="col.sortable">
            <router-link v-if="col.field === 'created_by'" :to="{ name: 'users.show', params: { slug: row[col.field] } }">
              {{ userNameById(row.created_by) }}
            </router-link>
            <router-link v-else-if="col.field === 'number'" :to="{ name: 'change-orders.edit', params: { slug: row['id'] } }">
              {{ row.number }}
            </router-link>
            <span v-else-if="col.field === 'created_at'">{{ $filters.datetime(row[col.field]) }}</span>
            <span v-else-if="col.field === 'updated_at'">{{ $filters.datetime(row[col.field]) }}</span>
            <span v-else>{{ row[col.field] }}</span>
          </o-table-column>
        </template>
      </template>
    </o-table>

    <div>Total: <strong>{{ total }}</strong></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Table from '../../mixins/Table'
import Datepicker from '../../components/Datepicker'

export default {
  mixins: [Table],

  components: {
    Datepicker
  },

  created () {
    this.filters = {
      from: '',
      to: '',
      companyId: ''
    }
  },

  data () {
    return {
      companyId: null,
      contactItem: null,
      currentCompany: null,
      isComponentModalActive: false,
      rows: [],
      total: 0,
      loading: false,
      sortField: "name",
      sortOrder: "desc",
      defaultSortOrder: "desc",
      page: 1,
      perPage: 20,
      columns: [],
    }
  },

  methods: {
    fetchReportData()  {
      this.loading = true;
      let params = {from: this.filters.from, to: this.filters.to, company: this.filters.companyId}
      axios.get('/api/reports/pending_change_orders', { params })
          .then(res => {
            this.rows = res.data.data.change_orders;
            this.total = res.data.data.change_orders.length;
            this.columns = res.data.data.columns;
            this.loading = false;
          })
    },

    onPageChange(p) {
      this.page = p;
      this.fetchReportData();
    },

    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
    },
  },

  computed: {
    ...mapGetters([
        'userNameById'
    ]),

    ...mapGetters({
      itemsByIds: 'companiesByIds'
    }),

  },

  beforeMount() {
    this.fetchReportData()
  },
}
</script>
